var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { memo, useState, useEffect, useRef } from 'react';
import { ToolbarButtons } from './Toolbar.Styles';
import { styled } from '@web/theme';
export var LinkField = memo(function (_a) {
    var url = _a.url, onSubmit = _a.onSubmit, onCancel = _a.onCancel;
    var inputRef = useRef(null);
    var _b = useState(''), value = _b[0], setValue = _b[1];
    useEffect(function () {
        var _a;
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, [inputRef]);
    useEffect(function () {
        setValue(url);
    }, [url]);
    var onChange = function (event) {
        var val = event.target.value;
        if (val > '')
            setValue(val);
        else
            onCancel();
    };
    var _onSubmit = function () {
        if (inputRef.current)
            onSubmit(inputRef.current.value);
    };
    return (React.createElement(ToolbarButtons, null,
        React.createElement(Wrapper, null,
            React.createElement(Wrapper, null,
                React.createElement("input", { ref: inputRef, type: "text", value: value, onChange: onChange }),
                value !== url && React.createElement("button", { onClick: _onSubmit }, "Pou\u017E\u00EDt"),
                value > '' && React.createElement("button", { onClick: onCancel }, "Odebrat")),
            React.createElement(Wrapper, null,
                React.createElement("small", null,
                    "P\u0159idat ",
                    React.createElement("strong", null, "https://"),
                    " pro extern\u00ED adresu")))));
});
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\n"], ["\n\n"])));
var templateObject_1;
